import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { AccessibilityWrapper } from "@/components/accessibility";
import { useI18n } from "@/shared/hooks";
import { TooltipInfos } from "@/components";
import { InfoCircleIcon } from "@gemini/icons";
import { usePriceLayout } from "@/components/Sections/Price/hooks/usePriceLayout";
import { PriceLayoutEnum } from "@/types/price";
export const IndividualPrice = ({ price, isLast = false, componentType, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const layout = usePriceLayout();
    const { t } = useI18n();
    if (!price)
        return null;
    const isPrimaryComponent = componentType === "PRIMARY";
    const priceWrapperStyles = isPrimaryComponent
        ? {}
        : {
            display: "flex",
            justifyContent: "space-between",
        };
    const priceLeftSectionStyles = isPrimaryComponent
        ? {}
        : {
            textAlign: "start",
        };
    const priceRightSectionStyles = isPrimaryComponent
        ? {
            display: "flex",
            alignItems: "baseline",
            gap: "spacing.8",
        }
        : {
            textAlign: "end",
        };
    const tooltipProps = {
        typography: layout === PriceLayoutEnum.FRENCH_SALE
            ? "typography.body.14.bold"
            : "typography.body.16.regular",
        color: "color.content.default.default",
        paddingHorizontal: "spacing.none",
        paddingVertical: "spacing.none",
        marginVertical: "-spacing.8",
    };
    const priceLeftSectionTypography = price.highlighted || layout === PriceLayoutEnum.FRENCH_SALE
        ? "typography.body.14.bold"
        : "typography.body.14.regular";
    const getMainValueTypography = () => {
        if (isPrimaryComponent) {
            return price.highlighted
                ? "typography.headline.22.bold"
                : "typography.headline.22.regular";
        }
        if (price.highlighted || layout === PriceLayoutEnum.FRENCH_SALE) {
            return "typography.body.14.bold";
        }
        return "typography.body.14.regular";
    };
    const mainValueTypography = getMainValueTypography();
    return (_jsxs(Box, Object.assign({}, priceWrapperStyles, { gap: "spacing.16", marginBottom: isLast ? "spacing.8" : "spacing.16", alignItems: "center", children: [_jsxs(Box, Object.assign({}, priceLeftSectionStyles, { children: [_jsx(Box, { typography: priceLeftSectionTypography, paddingBottom: isPrimaryComponent && !price.info && ((_a = price.label) === null || _a === void 0 ? void 0 : _a.main)
                            ? "spacing.4"
                            : "spacing.none", children: price.info ? (_jsx(TooltipInfos, { text: t(price.label.main), content: t(price.info.value), icon: _jsx(InfoCircleIcon, { size: layout === PriceLayoutEnum.FRENCH_SALE
                                    ? "sizing.16"
                                    : "sizing.24" }), tooltipProps: tooltipProps })) : (t((_b = price.label) === null || _b === void 0 ? void 0 : _b.main)) }), ((_c = price.label) === null || _c === void 0 ? void 0 : _c.alt) && (_jsx(Box, { typography: "typography.body.12.regular", color: "color.content.subdued.default", marginTop: "spacing.2", children: price.label.alt }))] })), _jsxs(Box, Object.assign({}, priceRightSectionStyles, { children: [_jsx(AccessibilityWrapper, { children: (_e = (_d = price.value) === null || _d === void 0 ? void 0 : _d.main) === null || _e === void 0 ? void 0 : _e.ariaLabel }), _jsx(Box, { as: "span", "aria-hidden": true, typography: mainValueTypography, children: (_g = (_f = price.value) === null || _f === void 0 ? void 0 : _f.main) === null || _g === void 0 ? void 0 : _g.value }), ((_h = price.value) === null || _h === void 0 ? void 0 : _h.alt) && (_jsx(Box, { "aria-label": (_j = price.value.alt) === null || _j === void 0 ? void 0 : _j.ariaLabel, typography: "typography.body.14.regular", color: "color.content.subdued.default", children: price.value.alt.value }))] })), (price === null || price === void 0 ? void 0 : price.subLabel) && (_jsx(Box, { typography: "typography.body.12.regular", color: "color.content.subdued.default", paddingTop: "spacing.4", children: price.subLabel }))] })));
};
